import { Box, Divider } from '@coolblue-development/becky';
import { Typography } from '@coolblue-development/freddy';
import { useState } from 'react';
import { EmailMessage } from '../../../../models/Email';
import ChevronIcon from '../../Icons/ChevronIcon';
import EmailMessageItem from './Body/EmailMessageItem';

interface PreviousEmailsAccordionProps {
  messages: EmailMessage[];
  onAttachmentDownloadError?: () => void;
}

const PreviousEmailsAccordion = ({
  messages,
  onAttachmentDownloadError
}: PreviousEmailsAccordionProps): JSX.Element | null => {
  const [open, setOpen] = useState(false);

  if (messages.length === 0) return null;

  const count = messages.length;
  const label = open
    ? `Hide ${count} previous email${count > 1 ? 's' : ''}`
    : `Show ${count} previous email${count > 1 ? 's' : ''}`;

  return (
    <Box sx={{ marginTop: '16px' }}>
      {open &&
        messages.map((message, index) => (
          <EmailMessageItem
            key={message.contactId}
            message={message}
            index={index}
            onAttachmentDownloadError={onAttachmentDownloadError}
          />
        ))}
      <Divider sx={{ marginX: '16px' }}>
        <Typography
          variant="h6"
          color="subtle"
          onClick={() => setOpen(!open)}
          sx={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '0px 12px'
          }}
        >
          <ChevronIcon rotation={open ? 90 : 270} color="#868A90" />
          {label}
        </Typography>
      </Divider>
    </Box>
  );
};

export default PreviousEmailsAccordion;
